// =============================
// Imports
// =============================

import styled, { css } from 'styled-components';
import { Div } from '@mewo/components';

import CoverUnstyled from '../../../containers/cover';

// =============================
// Component
// =============================

const coverMarginRight = '4.8rem';

const LeftSideMask = css`
  mask-image: linear-gradient(90deg, transparent 0%, #fff 16rem, #fff);
  mask-repeat: repeat-x;
  mask-mode: luminance;
`;

export const FixedWrapper = styled.div`
  ${LeftSideMask};
  align-items: center;
  bottom: 0;
  display: flex;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.text};
  font-weight: ${({ theme }) => theme.fontWeight.extrabold};
  font-size: 3rem;
  left: 18rem;
  position: relative;
  top: 15%;
`;

export const Wrapper = styled(Div)`
  display: inline-flex;
  padding-bottom: 16rem;
  padding-left: 18rem;
  padding-top: 13.5rem;

  &:after {
    content: '';
    display: block;
    height: 0.1rem;
    width: ${coverMarginRight};
  }
`;

export const ScrollArea = styled.div`
  ${({ theme }) => theme.helpers.hideScrollbar};
  overflow: auto;
  width: 100%;
`;

export const Cover = styled(CoverUnstyled)`
  flex-shrink: 0;
  transition: 600ms ${({ theme }) => theme.transitionTiming.easeOut};
  transition-delay: ${({ index }) => 100 * index}ms;
  width: 25rem;

  &:not(:last-child) {
    margin-right: 10rem;
  }

  &:last-child {
    margin-right: 4.8rem;
  }

  &:nth-of-type(2n) {
    position: relative;
    top: 12rem;
  }

  ${({ index, state }) => {
    switch (state) {
      case 'entering':
        return css`
          opacity: 0;
          transform: translate3d(${30 + index * 30}rem, -5rem, 0) scale(1.5);
        `;
      case 'entered':
        return css`
          opacity: 1;
          transform: translate3d(0, 0, 0) scale(1);
        `;
      case 'exiting':
        return css`
          opacity: 1;
          transform: translate3d(0, 0, 0) scale(1);
        `;
      case 'exited':
      default:
        return css`
          opacity: 0;
          transform: translate3d(${30 + index * 30}, -5rem, 0) scale(1.5);
        `;
    }
  }};
`;
